import { useState } from 'react';
import Layout from '@/components/Layout';
import { FileText, Plus } from 'lucide-react';
import { useOrders } from '@/components/orders/useOrders';
import OrderFilters from '@/components/orders/OrderFilters';
import OrderList from '@/components/orders/OrderList';
import CreateOrderModal from '@/components/orders/CreateOrderModal';
import DomiciliacionExportButton from '@/components/DomiciliacionExportButton';

export default function Orders() {
  const {
    projectId,
    orders,
    wallets,
    loading,
    filterStatus,
    setFilterStatus,
    filters,
    handleFilterChange,
    clearFilters,
    hasActiveFilters,
    loadOrders,
    createOrder,
  } = useOrders();

  const [showModal, setShowModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [copiedCode, setCopiedCode] = useState(null);

  const copyToClipboard = (text, code) => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedCode(code);
          setTimeout(() => setCopiedCode(null), 2000);
        })
        .catch((err) => {
          console.error('Clipboard error:', err);
          alert('Link copiado: ' + text);
          setCopiedCode(code);
          setTimeout(() => setCopiedCode(null), 2000);
        });
    } else {
      alert('Link de pago: ' + text);
    }
  };

  if (!projectId || projectId === 'all') {
    return (
      <Layout>
        <div className="flex items-center justify-center h-full p-12" data-testid="orders-no-project">
          <div className="text-center">
            <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
            <h2 className="text-xl font-semibold text-gray-700 mb-2">Selecciona un Proyecto</h2>
            <p className="text-gray-600">
              Las órdenes son específicas de cada proyecto. Selecciona un proyecto en el header.
            </p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold" style={{ color: '#051C2C' }}>Órdenes de Pago</h1>
            <p className="text-sm text-gray-600 mt-1">Gestiona órdenes con dispersión automática</p>
          </div>
          <div className="flex items-center gap-3">
            <DomiciliacionExportButton />
            <button
              onClick={() => setShowModal(true)}
              className="flex items-center gap-2 px-4 py-2 text-white rounded-lg"
              style={{ backgroundColor: '#003594' }}
              data-testid="create-order-button"
            >
              <Plus className="w-4 h-4" />
              Nueva Orden
            </button>
          </div>
        </div>

        <OrderFilters
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          filters={filters}
          handleFilterChange={handleFilterChange}
          clearFilters={clearFilters}
          hasActiveFilters={hasActiveFilters}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        />

        <OrderList
          orders={orders}
          loading={loading}
          hasActiveFilters={hasActiveFilters()}
          copiedCode={copiedCode}
          onCopy={copyToClipboard}
          onExpire={loadOrders}
          onCreate={() => setShowModal(true)}
          onClearFilters={clearFilters}
        />
      </div>

      <CreateOrderModal
        open={showModal}
        wallets={wallets}
        onClose={() => setShowModal(false)}
        onSubmit={createOrder}
      />
    </Layout>
  );
}
